import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import ReserveDetail from './pages/ReserveDetail'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reserves/:slug" element={<ReserveDetail />} />
      </Routes>
    </Layout>
  )
}

export default App
